import { RegionId, SoilTypeId } from "@omnia/shared/generated/enums";
import { FieldViewModel, isDefined, isUndefined } from "../omnia";
import { ISoilService } from "../types";

interface IOrganicMatterDefaults {
    max: number;
    smn: number;
}[]

const englandOrganicMatterDefaults = [
    { max: .06, smn: 0 },
    { max: .11, smn: 40 },
    { max: Number.POSITIVE_INFINITY, smn: 150 },
];

const englandSoilTypeDefaults = {
    [SoilTypeId.Organic]: 40,
    [SoilTypeId.Peat]: 150
}

const scotlandOrganicMatterDefaults = [
    { max: .11, smn: 0 },
    { max: .16, smn: 20 },
    { max: .20, smn: 60 },
    { max: Number.POSITIVE_INFINITY, smn: 100 },
];

const scotlandSoilTypeDefaults = {
    [SoilTypeId.Organic]: 20,
    [SoilTypeId.Peat]: 60
}

export function getDefaultSmn(svc: ISoilService, cropping: FieldViewModel): number {

    var smn = getDefaultSmnFromAnalysis(svc, cropping);

    if (isUndefined(smn)) {
        smn = getDefaultSmnFromSoilType(svc, cropping);
    }

    return smn;

}


function getDefaultSmnFromAnalysis(svc: ISoilService, cropping: FieldViewModel): number {

    var analysis = svc.getFieldSoilAnalyses(cropping.fieldId)

    if (analysis) {

        analysis = analysis.filter(sa => sa.Allocations.some(a => !a.ZoneId));

        analysis = analysis.sort((a1, a2) => a2.SamplingDate.valueOf() - a1.SamplingDate.valueOf());

        var currentAnalysis = analysis.find(a => a.SamplingDate < cropping.cropping.EndDate);

        if (currentAnalysis && isDefined(currentAnalysis.OrganicMatter)) {

            return getDefaultSmnFromOrganicMatter(svc, currentAnalysis.OrganicMatter);

        }

    }

    return undefined;

}

function getDefaultSmnFromOrganicMatter(svc: ISoilService, organicMatter: number): number {

    var scotland = svc.holding && (svc.holding.Region == RegionId.Scotland);

    var defaults: IOrganicMatterDefaults[] = (scotland ? scotlandOrganicMatterDefaults : englandOrganicMatterDefaults);

    var smn = defaults.find(d => d.max > organicMatter);

    if (smn) {
        return smn.smn;
    }

}

function getDefaultSmnFromSoilType(svc: ISoilService, cropping: FieldViewModel): number {

    var scotland = svc.holding && (svc.holding.Region == RegionId.Scotland);

    var defaults = (scotland ? scotlandSoilTypeDefaults : englandSoilTypeDefaults);

    return defaults[cropping.field.SoilTypeId];

}
